import { Base } from './base';
import { Product } from './product';

export class ParkingProduct extends Base {
    ParkingProductID?: string;
    ParkingID?: number;
    ProductID?: string;
    Date?: Date;

    // Navigation Properties
    Product?: Product;

    // Model Properties
    ParkingTitle?: string;
    Code?: string;
}
